module.exports = __webpack_public_path__ + "img/1f927.6f0c357.svg";